import { styled } from "@mui/material/styles";

export const LoaderWrapper = styled("div")(({ theme }) => ({
  height: "75vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
